import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import {
    registerBundleImpression as registerBundleImpressionEvent,
    registerAddBundleToCart as registerAddBundleToCartEvent,
} from 'ggApp/modules/gaAnalytics/actions';

import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { selectedRentalPlanSelector } from 'ggApp/modules/rentalPlan/selectors';
import { currentVariant as currentVariantSelector } from 'ggApp/modules/product/selectors';

import BundleSection from './BundleSection';

const enhance = compose(
    withDeviceInfo,
    connect(
        createStructuredSelector({
            selectedRentalPlan: selectedRentalPlanSelector,
            activeStore: activeStoreSelector,
            currentVariant: currentVariantSelector,
        }),
        (dispatch) => ({
            registerBundleImpression: bindActionCreators(registerBundleImpressionEvent, dispatch),
            registerAddBundleToCart: bindActionCreators(registerAddBundleToCartEvent, dispatch),
        }),
    ),
    withProps(({ userDevice }) => ({
        isDesktopUser: userDevice !== 'mobile' && userDevice !== 'tablet',
    })),
);

export default enhance(BundleSection);
